export default "__VITE_ASSET__D396sMvO__"